// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import siteMessage from "@insite/client-framework/SiteMessage";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

const events = ['resize', 'scroll'];

const getDataLayer = () => {
    return (window as any).dataLayer || [];
};

const getElementsToPushToDataLayer = (visibleElements: ProductModel[]) => {
    const dataLayer = getDataLayer();
    const productImpressions = dataLayer.filter((elem: any) => elem.event && elem.event.includes('ProductImpression'));

    if (productImpressions.length) {
        const elementsToPush: ProductModel[] = visibleElements?.filter((visibleElement: ProductModel) => {
            return !productImpressions.some((impression: any) => {
                return impression.ecommerce.impressions.some((item: any) =>
                    item.id === visibleElement?.productNumber
                );
            });
        });

        return elementsToPush;
    }
    return visibleElements;
};

const isInViewport = (elem: any) => {
    const bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

const rcBrand = siteMessage("Custom_Product_BrandName", "Royal Canin")

export { events, getDataLayer, getElementsToPushToDataLayer, isInViewport, rcBrand };

/* eslint-disable */
(function (window) {
    (window as any)._GaCheckoutFunnel = (
        step: number,
        cart: any,
        discount?: number,
        includeBrand?: boolean,
        includeCategory?: boolean,
    ) => {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }

        const GA4Data: any = {}
        if (step === 1) {
            GA4Data.event = "begin_checkout";
        } else if (step === 2) {
            GA4Data.event = "add_shipping_info";
            if (cart.carrier?.description) { 
                GA4Data["shipping_tier"] = cart.carrier?.description; 
            }
        } else if (step === 3) {
            GA4Data.event = "add_payment_info";
            if (cart.paymentMethod?.description) { 
                GA4Data["payment_type"] = cart.paymentMethod?.description 
            }
        }
        
        GA4Data.items = [];
        cart?.cartLines?.map((cartLine: any) => {
            const GA4DataItems = {
                item_name: cartLine.shortDescription,
                item_id: cartLine.erpNumber,
                price: cartLine?.pricing?.unitNetPrice || 0,
                quantity: cartLine.qtyOrdered,
            } as any;

            if (includeBrand) {
                GA4DataItems["item_brand"] = cartLine.brand?.name || "";
            }

            if (includeCategory) {
                GA4DataItems["item_category"] = cartLine.properties["category"];
                GA4DataItems["item_list_id"] = cartLine.properties["categoryId"];
            }

            GA4Data.items.push(GA4DataItems);
        });

        if (cart.orderGrandTotal) {
            GA4Data.value = cart.orderGrandTotal;
        }

        GA4Data.discount = discount || 0;
        GA4Data.event && dataLayer.push(GA4Data);
    };
})(typeof window != "undefined" ? window : {});
/* eslint-enable */
